import { ROUTES_PATHS } from 'routes/constants';

export const links = [
  { to: ROUTES_PATHS.home, name: 'Home' },
  { to: ROUTES_PATHS.about, name: 'About' },
  { to: ROUTES_PATHS.contact, name: 'Contact' },
];

export const handleClassName = ({ isActive }) => `${isActive
  ? 'text-purple-80'
  : 'text-gray-50'} hover:text-purple-80 duration-300 p-2 md:px-4 md:py-4 md:rounded-lg`;

export const logoClassNames = 'flex items-center justify-between h-[70px] mr-auto ml-auto px-[30px] max-w-[1500px]';

export const logoInner = 'flex items-center font-700 text-purple-100 gap-[7px] text-20';

const mobileClasses = 'md:top-[71px] duration-300 md:fixed md:left-0 md:right-0 md:flex-col md:bg-white md:shadow-2xl overflow-hidden';
export const handleNavClassNames = (isVisibleMenu) =>
  `flex gap-x-4 ${mobileClasses} ${(isVisibleMenu ? 'md:h-[144px]' : 'md:h-0 md:p-0')}`;

export const handleMobMenuClassNames = (isVisibleMenu) => `mobile-menu${isVisibleMenu ? ' opened' : ''} xl:hidden`;
